import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { INetworkRequestService } from '../../../base/request/network-request.interface';
import { getFormDataWithParams } from '../../../base/utils';
import { CAN_MOVE, COLLECT, CREATE_DOC, DOC_HUMTRANS, GET_COLLECT, RECOVER, } from './cgi-path';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { addURLParameters } from '@tencent/ark-utils/lib/url';
var FileRepository = /** @class */ (function () {
    function FileRepository(networkRequestService) {
        this.networkRequestService = networkRequestService;
    }
    FileRepository.prototype.collect = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign(__assign({}, params), { xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }));
                return [2 /*return*/, this.networkRequestService.instance.post(COLLECT, formData)];
            });
        });
    };
    FileRepository.prototype.getDocCollect = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var query, url;
            return __generator(this, function (_a) {
                query = __assign(__assign({}, params), { xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)) });
                url = addURLParameters(GET_COLLECT, query);
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    FileRepository.prototype.createDoc = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign(__assign({}, params), { xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }));
                return [2 /*return*/, this.networkRequestService.instance.post(CREATE_DOC, formData)];
            });
        });
    };
    FileRepository.prototype.recover = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign(__assign({}, params), { xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }));
                return [2 /*return*/, this.networkRequestService.instance.post(RECOVER, formData)];
            });
        });
    };
    FileRepository.prototype.docHumtrans = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign(__assign({}, params), { xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }));
                return [2 /*return*/, this.networkRequestService.instance.post(DOC_HUMTRANS, formData)];
            });
        });
    };
    FileRepository.prototype.canMove = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var query, url;
            return __generator(this, function (_a) {
                query = __assign(__assign({}, params), { xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)) });
                url = addURLParameters(CAN_MOVE, query);
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    FileRepository = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object])
    ], FileRepository);
    return FileRepository;
}());
export { FileRepository };
